// src/queries/usage.js
// Thin API client for the usage-series endpoint. Exact mirror of
// queries/users.js — RequestBuilder handles auth + retry; every module
// chains `.then(toJSON)` since RequestBuilder.fetch() resolves to the raw
// Response.
import { RequestBuilder, toJSON } from "./request";

const BASE = "/api/admin/entitlements/usage";

export const fetchUsageSeries = (authData) =>
  new RequestBuilder(BASE)
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch()
    .then(toJSON);
